import ToggleSwitch from '../../../components/Forms/Input/ToggleSwitch';

interface Props {
  label: string;
  description: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const RestaurantSettingsToggle = ({
  label,
  description,
  name,
  checked,
  onChange,
  disabled = false,
}: Props) => (
  <div
    className={`mb-5 rounded-xl border border-stroke bg-gray-2 px-5 py-5 transition-all duration-200 hover:border-primary/20 dark:border-strokedark dark:bg-meta-4/20 ${
      disabled ? 'opacity-50' : ''
    }`}
  >
    <ToggleSwitch
      label={label}
      name={name}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />

    <p className="mt-2 pr-16 text-xs leading-5 text-bodydark2 dark:text-bodydark">
      {description}
    </p>
  </div>
);

export default RestaurantSettingsToggle;